import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import './ProtectedCreador.css';

const ProtectedCreador = () => {
  const [showBanner, setShowBanner] = useState(false);
  const location = useLocation();

useEffect(() => {
    // Solo interceptar el botón atrás cuando estamos en panel_creador
    if (location.pathname !== '/panel_creador') return;

    window.history.pushState(null, '', window.location.href);

    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
      setShowBanner(true);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [location.pathname]);

  const handleConfirmar = async () => {
    try {
      await fetch(`${process.env.REACT_APP_AUTH_CREADOR_URL}/logout.php`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (e) {
      console.error('Error al cerrar sesi�n:', e);
    }
    setShowBanner(false);
    window.location.href = '/';
  };

  const handleCancelar = () => {
    setShowBanner(false);
  };

  return (
    <>
      <Outlet />

{showBanner && (
        <div className="pc-overlay">
          <div className="pc-banner">
            <div className="pc-banner-icono">{'\u26A0\uFE0F'}</div>
            <p className="pc-banner-titulo">{'\u00BFEst\u00E1s seguro que quieres salir?'}</p>
            <p className="pc-banner-subtexto">
              {'Se cerrar\u00E1 tu sesi\u00F3n y deber\u00E1s volver a iniciarla para continuar.'}
            </p>
            <div className="pc-banner-botones">
              <button className="pc-btn-cancelar" onClick={handleCancelar}>
                Quedarme
              </button>
              <button className="pc-btn-confirmar" onClick={handleConfirmar}>
                {'S\u00ED, salir'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProtectedCreador;